// extracted by mini-css-extract-plugin
export default {"button":"LoginModal_button__b42Y4"};